import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

fetch('assets/env.js')
  .then((res) => res.text())
  .then((content) => {
    console.log('[main.ts] Contenu env.js:', content);
    // injecte les variables dans `window.env`
    eval(content);

    // Ensuite seulement, importe le vrai environment
    return import('./environments/environment');
  })
  .then(({ environment }) => {
    // ✅ Ajoute ceci
    console.log('[main.ts] ENV URL:', environment.url); // ✅ Et ça
    if (environment.production) {
      enableProdMode();
    }

    return platformBrowserDynamic().bootstrapModule(AppModule);
  })
  .catch((err) => console.error('Erreur de chargement env.js :', err));
